import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link } from "@quintype/components";
import "./bread-crumb.m.css";

export default function BreadCrumbs({ currentPath, displayName = "" }) {
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const allSections = get(qtConfig, ["sections"]);

  let path = "";

  if (currentPath.includes("#")) {
    const lastIndex = currentPath.indexOf("#");
    path = currentPath.slice(0, lastIndex);
  } else {
    path = currentPath.slice(0);
  }

  const sectionSlugs = path.split("/");

  const [firstSection, ...restSections] = sectionSlugs?.slice(0,-1);

  const getSectionObject = (slug, parentId = null) =>
    allSections?.find((section) => section?.slug === slug && section?.["parent-id"] === parentId) || null;

  let breadCrums = [];


  function buildBreadCrumbs(sectionSlugs, parentSectionId = null, breadCrums = []) {
    if (sectionSlugs.length === 0) return breadCrums;

    const [currentSlug, ...remainingSlugs] = sectionSlugs;
    const currentSection = getSectionObject(currentSlug, parentSectionId);

    if (currentSection) {
      breadCrums.push(currentSection);
      return buildBreadCrumbs(remainingSlugs, currentSection.id, breadCrums);
    }

    return breadCrums;
  }

   breadCrums = buildBreadCrumbs(sectionSlugs);

  if (breadCrums.length < 2) {
    return null;
  }
  return (
    <div styleName="breadcrum-wrapper">
      {displayName ? (
        <div styleName="breadcrum-items">
          <Link href={currentPath}>{displayName}</Link>
        </div>
      ) : (
        breadCrums?.map((item, index) => {
          return (
            <div styleName="breadcrum-items" key={index}>
              <Link href={item?.["section-url"]}>{item?.["display-name"] || item?.name}</Link>
              {index !== breadCrums.length - 1 && <span styleName="slash-separator"> / </span>}
            </div>
          );
        })
      )}
    </div>
  );
}
